module.exports = __webpack_public_path__ + "static/media/valencia-18.6105aa06.jpg";